module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-03-image-03.d05f7cf6.png";